import { useMemo } from "react";
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { DASHBOARD_COLORS } from "@/lib/dashboardColors";
import { formatCurrency } from "@/utils/format";

export default function TopCustomersChart({ data = [], isLoading, error }) {
  const gridColor = useMemo(() => {
    if (typeof document === "undefined") return "#e2e8f0";
    return document.documentElement.classList.contains("dark") ? "#334155" : "#e2e8f0";
  }, []);
  const axisColor = "#475569";

  return (
    <Card data-testid="top-customers-chart">
      <CardHeader>
        <CardTitle>Top Kunden</CardTitle>
      </CardHeader>
      <CardContent className="h-72">
        {isLoading && <Skeleton className="h-full w-full" data-testid="top-customers-loading" />}
        {!isLoading && error && (
          <div className="text-sm text-red-600" data-testid="top-customers-error">
            Kunden-Daten konnten nicht geladen werden.
          </div>
        )}
        {!isLoading && !error && data.length === 0 && (
          <div className="text-sm text-gray-500" data-testid="top-customers-empty">
            Keine Kunden im gewählten Zeitraum.
          </div>
        )}
        {!isLoading && !error && data.length > 0 && (
          <div className="flex h-full flex-col">
            <div className="flex-1">
              <ResponsiveContainer width="100%" height="100%" minHeight={200} minWidth={200}>
                <BarChart
                  data={data}
                  layout="vertical"
                  margin={{ top: 10, right: 20, left: 30, bottom: 0 }}
                >
                  <CartesianGrid stroke={gridColor} strokeDasharray="3 3" />
                  <XAxis type="number" stroke={axisColor} tick={{ fill: axisColor }} />
                  <YAxis dataKey="name" type="category" stroke={axisColor} tick={{ fill: axisColor }} width={120} />
                  <Tooltip formatter={(value) => formatCurrency(value)} labelFormatter={(label) => `Kunde: ${label}`} />
                  <Bar
                    dataKey="revenue"
                    fill={DASHBOARD_COLORS.revenue}
                    name="Umsatz"
                    radius={[0, 0, 0, 0]}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
            <div className="flex items-center gap-2 pt-2 text-xs text-slate-500" data-testid="top-customers-legend">
              <span
                className="h-2 w-2 rounded-full"
                style={{ backgroundColor: DASHBOARD_COLORS.revenue }}
              />
              Umsatz
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}